<section class="section section-1">

    <div class="container">

        <div class="row align-items-center gy-5 gx-lg-5">
            <!-- Left -->
            <div
                class="col-lg-5 justify-content-center d-flex flex-column align-items-center text-center align-items-lg-start text-lg-start">

                <span class="section-badge">
                    {{ 'meetClockFlex.badge' | translate }}
                </span>

                <h2 class="section-title">
                    {{ 'heroSection.Meet_Clockflex' | translate }}
                </h2>

                <p class="section-subtitle">
                    {{ 'meetClockFlex.subtitle' | translate }}
                </p>

                <div class="feature-list d-flex flex-column align-items-center align-items-lg-start">

                    <div class="feature-item">
                        <i class="fas fa-check-circle"></i>
                        <span>{{ 'meetClockFlex.feature1' | translate }}</span>
                    </div>

                    <div class="feature-item">
                        <i class="fas fa-check-circle"></i>
                        <span>{{ 'meetClockFlex.feature2' | translate }}</span>
                    </div>

                    <div class="feature-item">
                        <i class="fas fa-check-circle"></i>
                        <span>{{ 'meetClockFlex.feature3' | translate }}</span>
                    </div>

                    <div class="feature-item">
                        <i class="fas fa-check-circle"></i>
                        <span>{{ 'meetClockFlex.feature4' | translate }}</span>
                    </div>

                </div>

            </div>

            <!-- Right -->
            <div class="col-lg-7">

                <div class="video-card">

                    <div class="video-glow"></div>

                    <div class="ratio ratio-16x9">

                        <iframe src="https://www.youtube.com/embed/Te5yfixipXc?rel=0&modestbranding=1"
                            title="ClockFlex Intro" loading="lazy"
                            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen>
                        </iframe>

                    </div>

                </div>

            </div>

        </div>

    </div>

</section>